import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
const loanConfig = validationConfig['loan']

// eslint-disable-next-line import/prefer-default-export
export const ApplyLoanSchema = Yup.object().shape({
  loanAmount: loanConfig['isLoanAmountRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_AMOUNT))
    : Yup.string().optional(),
  loanPurpose: loanConfig['isLoanPurposeRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_PURPOSE))
    : Yup.string().optional(),
  tenureMonthlyOrYearly: loanConfig['isTenureMonthlyOrYearlyRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_TENURE))
    : Yup.string().optional(),
  tenureValue: loanConfig['isTenureValueRequired']
    ? Yup.number()
        .min(1, i18n.t(VALIDATION_MESSAGES.LOAN_TENURE_VALUE_MIN))
        .required(i18n.t(VALIDATION_MESSAGES.LOAN_TENURE_VALUE))
    : Yup.number().optional(),
  sourceOfIncome: loanConfig['isSourceOfIncomeRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_SOURCE_INCOME))
    : Yup.string().optional(),
  loanCurrency: loanConfig['isLoanCurrencyRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_CURRENCY))
    : Yup.string().optional(),
  incomeRange: loanConfig['isIncomeRangeRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_INCOME_RANGE))
    : Yup.string().optional(),
})

export const LoanRepaymentSchema = Yup.object().shape({
  srcAccountNo: loanConfig['isSrcAccountNoRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_SOURCE_ACC_NO))
    : Yup.string().optional(),
  loanAccountNo: loanConfig['isLoanAccountNoRequired']
    ? Yup.string().required(i18n.t(VALIDATION_MESSAGES.LOAN_ACCOUNT_NO))
    : Yup.string().optional(),
})
